<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <base-card>
          <v-card-text>
            <div
              class="mx-auto"
              style="width: 90%;"
            >
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left pl-0 text-body-2">
                        INSTANCE
                      </th>
                      <th class="text-left pl-0 text-body-2">
                        DISTRIB PACK
                      </th>
                      <th class="text-left pl-0 text-body-2 text-right">
                        CHANNELS
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="operator in scOperators"
                      :key="operator.id"
                      class="text--pointer"
                      @click="goToOperator(operator)"
                    >
                      <td
                        class="font-weight-bold text-body-1 pl-0"
                      >
                        {{ operator.extId }}
                      </td>
                      <td class="pl-0">
                        <span
                          v-if="operator.distributionPackage.name"
                          class="font-weight-bold text-body-1 text-primary"
                        >
                          {{ operator.distributionPackage.name }}
                        </span>
                        <span
                          v-else
                          class="grey--text"
                        >
                          not set
                        </span>
                      </td>
                      <td
                        class="font-weight-bold text-body-1 pr-0 text-right"
                      >
                        {{ operator.channelCount || 0 }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-card-text>
        </base-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { processDistributionPackage, processSCOperator } from '@/store/converters'

  export default {
    metaInfo: {
      title: 'SotalCloud Instances',
    },
    data () {
      return {
        scOperators: [],
        distributionPackages: [],
        newPackageDialog: false,
        newDistribPack: {
          name: '',
          mtPrefix: '',
          mtPrerollPrefix: '',
        },
        rules: {
          nameRules: [
            (v) => !!v || 'Name is required',
            (v) => (v && v.length <= 1024) || 'Name must be less than 1024 characters',
          ],
        },
        deletedDistribPack: {},
        removeDialog: false,
        reportLoading: false,
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      isFormValid () {
        if (!(this.newDistribPack.name.length >= 3 && this.newDistribPack.name.length <= 255)) {
          return false
        }
        return true
      },
    },
    created () {
      this.getDistributionPackages()
      this.loadData()
    },
    methods: {
      getDistributionPackages () {
        this.$store.commit('setPageLoader')

        const args = {
        }
        const distribPackReq = this.$store.dispatch('distributionPackages', args)

        return Promise.all([distribPackReq])
          .then((res) => {
            const packages = res[0]
            const processed = packages.map((d) => processDistributionPackage(d))
            const index = {}
            for (let i = 0; i < processed.length; i += 1) {
              const parts = processed[i].mtPrefix.split('/')
              if (parts.length > 2) {
                processed[i].mtSuffix = parts[parts.length - 1] !== '' ? parts[parts.length - 1] : parts[parts.length - 2]
                processed[i].mtSuffix = '../' + processed[i].mtSuffix
                index[processed[i].id] = i
              }
            }

            this.distributionPackages = processed
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
            this.$router.push({ name: 'ChannelsPage' })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      loadData () {
        this.$store.commit('setPageLoader')

        const args = {
          $expand: 'distribution_package',
        }
        const scOperatorsReq = this.$store.dispatch('scOperators', args)

        const operatorsStatReq = this.$store.dispatch('operatorsStat')

        return Promise.all([scOperatorsReq, operatorsStatReq])
          .then((res) => {
            const operators = res[0]
            const processed = operators.map((d) => processSCOperator(d))

            const stat = res[1] || []
            const opMap = {}
            for (let i = 0; i < stat.length; i += 1) {
              const s = stat[i]
              opMap[s.OperatorId] = s.ChannelCount
            }
            for (let i = 0; i < processed.length; i += 1) {
              processed[i].channelCount = 0
              // eslint-disable-next-line no-prototype-builtins
              if (opMap.hasOwnProperty(processed[i].id)) {
                processed[i].channelCount = opMap[processed[i].id]
              }
            }

            this.scOperators = processed
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      goToDetails (distribution) {
        this.$router.push({
          name: 'Distribution',
          params: {
            distribution_id: distribution.id,
          },
        })
      },
      goToOperator (operator) {
        this.$router.push({
          name: 'SotalCloudOperator',
          params: {
            operator_id: operator.id,
          },
        })
      },
      newPackage () {
        this.newPackageDialog = true
      },
      saveNewDistribPackage () {
        if (!this.isFormValid) return

        this.$store.commit('setPageLoader')
        const distribPack = {
          name: this.newDistribPack.name,
          mt_prefix: this.newDistribPack.mtPrefix,
          mt_preroll_prefix: this.newDistribPack.mtPrerollPrefix,
        }

        this.$store.dispatch('createDistributionPackage', distribPack)
          .then((pack) => {
            this.$store.commit('showSnackbar', {
              text: 'The distribution package has been successfully created',
              timeout: 3000,
              color: 'success',
            })
            this.goToDetails(pack)
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.newPackageDialog = false
            this.$store.commit('resolvePageLoader')
          })
      },
      openRemoveDialog (pack) {
        this.deletedDistribPack = pack
        this.removeDialog = true
      },
      deleteDistribPack () {
        if (!this.deletedDistribPack.id) return

        this.$store.commit('setPageLoader')
        this.$store.dispatch('deleteDistributionPackage', this.deletedDistribPack.id)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The distribution package has been successfully removed',
              timeout: 6000,
              color: 'success',
            })
            this.getDistributionPackages()
            this.deletedDistribPack = {}
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.removeDialog = false
            this.$store.commit('resolvePageLoader')
          })
      },
      exportXLS () {
        this.reportLoading = true
        this.$store.dispatch('exportAllDistributions')
          .then((response) => {
            const blob = new Blob([response.data], { type: response.data.type })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = 'Playout Distributions'
            link.click()
            URL.revokeObjectURL(link.href)
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.reportLoading = false
          })
      },
    },
  }
</script>

<style>
@media (min-width: 1200px) {
  .container {
    max-width: 1320px !important;
  }
}
</style>
